module.exports = __webpack_public_path__ + "MaterialIcons-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./~/material-design-icons-iconfont/dist/fonts/MaterialIcons-Regular.woff
// module id = 82
// module chunks = 0